/* クリスマスケーキのご予約フォーム（2026-10-17）
 *
 * デコレーションケーキのご予約（assets/cake-order.js）と同じ流れです。お客様に
 * 伺うことも、入力の確かめ方も、文言も揃えてあります。違うのは三つだけ:
 *
 *   ・お選びいただくのは決まった4種類で、飾りもメッセージプレートもありません
 *   ・お受け取りは12月22日から26日まで
 *   ・お支払いはオンライン決済のみ
 *
 * ここはページ本文まで含めてテーマの中にあるので、デコレーションケーキのように
 * 描画後の書き換えでしのぐ必要がありません。入力欄もこのファイルが作ります。
 */

/* ── お店からいただいた一覧のとおり。価格は税込（お持ち帰りなので8%）。 ── */
const XC_CAKES = [
  {
    key: 'short',
    name: 'ショートクリスマス',
    photo: 'tft-xmas-short.jpg',
    note: '',
    sizes: [
      { size: '4号', price: 4860 },
      { size: '5号', price: 6264 },
      { size: '6号', price: 8964 },
    ],
  },
  {
    key: 'ganache',
    name: 'ガナッシュクリスマス',
    photo: 'tft-xmas-ganache.jpg',
    note: '',
    sizes: [
      { size: '4号', price: 4536 },
      { size: '5号', price: 5832 },
      { size: '6号', price: 7020 },
    ],
  },
  {
    key: 'mousseline',
    name: 'ノエルムースリーヌ',
    photo: 'tft-xmas-mousseline.jpg',
    note: 'ホワイトチョコと苺のムースの上に、真っ赤な木苺ジュレ。濃厚でザクザクのピスタチオカダイフを仕込んでいます。',
    sizes: [{ size: '6号', price: 6264 }],
  },
  {
    key: 'buche',
    name: 'ブッシュドモンブラン',
    photo: 'tft-xmas-buche-montblanc.jpg',
    note: 'タイムフォーティーで大人気のモンブラン「モンブランショート」と「栗のモンブラン」のコラボケーキ。チョコも入っています。',
    sizes: [{ size: '6号', price: 6264 }],
  },
];

/* お受け取りの日。曜日はここでは書かず、日付から出します（書き間違いを防ぐため）。 */
const XC_DATES = ['2026-12-22', '2026-12-23', '2026-12-24', '2026-12-25', '2026-12-26'];

/* お受け取りのお時間。デコレーションケーキと同じ 10:00〜19:00 の30分刻み。 */
function xcTimes() {
  const out = [];
  for (let h = 10; h <= 18; h++) {
    out.push(h + ':00');
    out.push(h + ':30');
  }
  out.push('19:00');
  return out;
}

/* 1日・1種類あたりのお作りできる数。
 *
 * この数をここで持っているのは表示のためだけで、受付を止める力はありません。
 * 止めるには「その日その種類で何件入っているか」を数える必要があり、それは
 * サーバー側の仕事です。数える口ができるまで xcRemaining() は null を返し、
 * どの日もお選びいただけるままにしてあります。嘘の残数を出すよりは、
 * 何も言わないほうがよいためです。 */
const XC_DAILY_LIMIT = 60;

function xcRemaining(/* isoDate, cakeKey */) {
  return null;
}

/* Shopify の商品。オンライン決済はこの商品をカートに入れて進みます。
 * バリエーションは「ケーキ名｜サイズ」で引きます。サイズは「4号」でも
 * 「4号（2〜4名）」でも通るように、かっこ書きを落として比べます。 */
const XC_PRODUCT_HANDLE = 'christmas-cake';
const xcVariantMap = {};

function xcSizeKey(s) {
  return String(s || '').replace(/[（(].*$/, '').trim();
}

function xcVariantKey(name, size) {
  return name + '|' + xcSizeKey(size);
}

async function xcFetchVariants() {
  try {
    const r = await fetch('/products/' + XC_PRODUCT_HANDLE + '.json');
    if (!r.ok) throw new Error('HTTP ' + r.status);
    const data = await r.json();
    (data.product.variants || []).forEach(function (v) {
      xcVariantMap[xcVariantKey(v.option1, v.option2)] = v.id;
    });
  } catch (e) {
    console.warn('クリスマスケーキの商品を取得できませんでした', e);
  }
}

/* ── お客様が選んだもの ── */
const xcSel = { cake: null, size: null, price: 0, date: null, time: null };

/* ── 日付まわり ── */
const XC_WEEKDAYS = ['日', '月', '火', '水', '木', '金', '土'];

/* ISO の文字列から読む。new Date(iso) の時差で前日になるのを避けるため、
 * 日付の計算はいったん正午で作ってから曜日だけを見ます。 */
function xcDateParts(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return null;
  const y = Number(m[1]), mo = Number(m[2]), d = Number(m[3]);
  const wd = new Date(y, mo - 1, d, 12, 0, 0).getDay();
  return { y: y, m: mo, d: d, wd: wd };
}

function xcShortDate(iso) {
  const p = xcDateParts(iso);
  return p ? p.m + '/' + p.d + '（' + XC_WEEKDAYS[p.wd] + '）' : iso;
}

function xcLongDate(iso) {
  const p = xcDateParts(iso);
  return p ? p.y + '年' + p.m + '月' + p.d + '日（' + XC_WEEKDAYS[p.wd] + '）' : iso;
}

function xcYen(n) {
  return '¥' + Number(n).toLocaleString('ja-JP');
}

/* ── 入力の確かめ方。デコレーションケーキと同じ文言です。 ── */
function xcDigitCount(value) {
  return String(value)
    .replace(/[０-９]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xfee0); })
    .replace(/[^0-9]/g, '').length;
}

/* IME を入れたまま打たれた ０９０−… も同じ番号として送ります。ダッシュは
 * 見た目の似た文字が何種類もあり、全角ハイフン・長音・マイナス記号（U+2212、
 * 日本語入力で「ー」を変換すると出ます）まで半角の - に揃えます。 */
function xcHalfWidthPhone(value) {
  return String(value)
    .replace(/[０-９]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xfee0); })
    .replace(/[‐‑‒–—―ー－−]/g, '-')
    .trim();
}

/* 姓の欄に姓名まとめて打たれたら、空白で分けて名の欄へ送ります。 */
function xcSplitWholeName() {
  const family = document.getElementById('xc-family');
  const given = document.getElementById('xc-given');
  if (!family || !given || given.value.trim()) return;
  const parts = family.value.trim().split(/[\s　]+/).filter(Boolean);
  if (parts.length < 2) return;
  given.value = parts.slice(1).join(' ');
  family.value = parts[0];
}

function xcReadContact() {
  xcSplitWholeName();
  const familyEl = document.getElementById('xc-family');
  const givenEl = document.getElementById('xc-given');
  const phoneEl = document.getElementById('xc-phone');
  const emailEl = document.getElementById('xc-email');

  const family = familyEl.value.trim();
  const given = givenEl.value.trim();
  const phone = xcHalfWidthPhone(phoneEl.value.trim());
  const email = emailEl.value.trim();

  const problem =
    !family ? [familyEl, '姓をご入力ください。'] :
    !given ? [givenEl, '名をご入力ください。'] :
    !phone ? [phoneEl, 'お電話番号をご入力ください。'] :
    (xcDigitCount(phone) < 10 || xcDigitCount(phone) > 11)
      ? [phoneEl, 'お電話番号は数字10〜11桁でご入力ください。（例：0740-20-6529）'] :
    !email ? [emailEl, 'メールアドレスをご入力ください。'] :
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
      ? [emailEl, 'メールアドレスの形式でご入力ください。（例：tea@example.com）'] :
    null;

  if (problem) {
    alert(problem[1]);
    if (problem[0]) problem[0].focus();
    return null;
  }
  return { name: family + ' ' + given, family: family, given: given, phone: phone, email: email };
}

/* ── 画面の切り替え ── */
const XC_STEPS = 4;

function xcGoTo(step) {
  for (let i = 1; i <= XC_STEPS; i++) {
    const panel = document.getElementById('xc-step' + i);
    if (panel) panel.hidden = i !== step;
    const tab = document.getElementById('xc-tab' + i);
    if (tab) {
      tab.classList.remove('xc-tab-active', 'xc-tab-done');
      if (i < step) tab.classList.add('xc-tab-done');
      if (i === step) tab.classList.add('xc-tab-active');
    }
  }
  if (step === 4) xcRenderConfirm();
  const top = document.getElementById('xc-form');
  if (top && top.scrollIntoView) top.scrollIntoView({ block: 'start' });
}

/* ── ①ケーキ ── */
function xcRenderCakes() {
  const host = document.getElementById('xc-cakes');
  if (!host) return;
  host.innerHTML = '';
  XC_CAKES.forEach(function (cake) {
    cake.sizes.forEach(function (s) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'xc-choice';
      btn.dataset.cake = cake.key;
      btn.dataset.size = s.size;
      btn.innerHTML =
        '<span class="block font-semibold text-foreground">' + cake.name + '</span>' +
        '<span class="mt-1 block text-sm text-foreground/70">' + s.size + '</span>' +
        '<span class="mt-2 block text-lg font-semibold tabular-nums text-foreground">' + xcYen(s.price) + '</span>' +
        '<span class="block text-xs text-foreground/60">税込</span>';
      btn.addEventListener('click', function () {
        xcSel.cake = cake;
        xcSel.size = s.size;
        xcSel.price = s.price;
        xcMarkChosen(host, btn);
        xcUpdateBar();
        document.getElementById('xc-next1').disabled = false;
      });
      host.appendChild(btn);
    });
  });
}

function xcMarkChosen(host, btn) {
  host.querySelectorAll('.xc-choice').forEach(function (b) { b.classList.remove('xc-chosen'); });
  btn.classList.add('xc-chosen');
}

/* 上の価格表から選ばれたとき。
 *
 * 値段も組み合わせも、選んだあとの扱いも、すべてフォームの .xc-choice が
 * 持っています。ここはそのボタンを探して押すだけ。二か所に同じ判断を置くと、
 * 片方だけ直して食い違うためです。 */
function xcPickFromLineup(key, size) {
  const btn = document.querySelector(
    '#xc-cakes .xc-choice[data-cake="' + key + '"][data-size="' + size + '"]',
  );
  if (!btn) return;
  btn.click();
  xcGoTo(1);
}

/* ── ②お受け取り ── */
function xcRenderDates() {
  const host = document.getElementById('xc-dates');
  if (!host) return;
  host.innerHTML = '';
  XC_DATES.forEach(function (iso) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'xc-choice';
    btn.dataset.date = iso;
    const left = xcRemaining(iso, xcSel.cake && xcSel.cake.key);
    btn.innerHTML =
      '<span class="block text-lg font-semibold text-foreground">' + xcShortDate(iso) + '</span>' +
      (left === null ? '' : '<span class="mt-1 block text-xs text-foreground/60">残り ' + left + '個</span>');
    btn.addEventListener('click', function () {
      xcSel.date = iso;
      xcMarkChosen(host, btn);
      xcUpdateBar();
      xcCheckStep2();
    });
    host.appendChild(btn);
  });
}

function xcRenderTimes() {
  const host = document.getElementById('xc-times');
  if (!host) return;
  host.innerHTML = '';
  xcTimes().forEach(function (t) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'xc-choice xc-choice-sm';
    btn.textContent = t;
    btn.addEventListener('click', function () {
      xcSel.time = t;
      xcMarkChosen(host, btn);
      xcUpdateBar();
      xcCheckStep2();
    });
    host.appendChild(btn);
  });
}

function xcCheckStep2() {
  const btn = document.getElementById('xc-next2');
  if (btn) btn.disabled = !(xcSel.date && xcSel.time);
}

/* ── ③お客様情報 ── */
function xcCheckStep3() {
  const btn = document.getElementById('xc-next3');
  if (!btn) return;
  const filled = ['xc-family', 'xc-given', 'xc-phone', 'xc-email'].every(function (id) {
    const el = document.getElementById(id);
    return el && el.value.trim();
  });
  const agreed = Array.prototype.every.call(
    document.querySelectorAll('[data-xc-agree]'),
    function (b) { return b.checked; },
  );
  btn.disabled = !(filled && agreed);
  const hint = document.getElementById('xc-agree-hint');
  if (hint) {
    const left = Array.prototype.filter.call(
      document.querySelectorAll('[data-xc-agree]'),
      function (b) { return !b.checked; },
    ).length;
    hint.hidden = left === 0;
    hint.textContent = left ? 'あと ' + left + ' 件、ご確認のチェックをお願いいたします。' : '';
  }
}

/* ── ④ご確認 ── */
function xcRenderConfirm() {
  const host = document.getElementById('xc-confirm');
  if (!host || !xcSel.cake) return;
  const family = document.getElementById('xc-family').value.trim();
  const given = document.getElementById('xc-given').value.trim();
  const remarks = document.getElementById('xc-remarks').value.trim();
  const rows = [
    ['ケーキ', xcSel.cake.name],
    ['サイズ', xcSel.size],
    ['お受け取り日', xcLongDate(xcSel.date)],
    ['お受け取り時間', xcSel.time],
    ['お名前', family + ' ' + given + ' 様'],
    ['お電話番号', xcHalfWidthPhone(document.getElementById('xc-phone').value.trim())],
    ['メールアドレス', document.getElementById('xc-email').value.trim()],
  ];
  if (remarks) rows.push(['ご要望', remarks]);
  rows.push(['お支払い', 'オンライン決済']);
  rows.push(['合計', xcYen(xcSel.price) + '（税込）']);

  host.innerHTML = rows.map(function (r) {
    return '<div class="flex justify-between gap-4 border-t border-border py-3">' +
      '<span class="text-foreground/70">' + xcEscape(r[0]) + '</span>' +
      '<span class="text-right font-medium text-foreground">' + xcEscape(r[1]) + '</span>' +
      '</div>';
  }).join('');
}

function xcEscape(s) {
  return String(s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/* ── 下に出ている選択中の帯 ── */
function xcUpdateBar() {
  const bar = document.getElementById('xc-bar');
  if (!bar) return;
  const bits = [];
  if (xcSel.cake) bits.push(xcSel.cake.name + ' ' + xcSel.size);
  if (xcSel.date) bits.push(xcShortDate(xcSel.date));
  if (xcSel.time) bits.push(xcSel.time);
  const text = document.getElementById('xc-bar-text');
  const price = document.getElementById('xc-bar-price');
  if (text) text.textContent = bits.join('　/　');
  if (price) price.textContent = xcSel.cake ? xcYen(xcSel.price) : '';
  bar.hidden = bits.length === 0;
  /* 帯は画面の下に貼り付いているので、出ているあいだはページの下を
     その分だけ空けます（下に隠れる中身が出ないように）。 */
  document.body.classList.toggle('xc-bar-on', !bar.hidden);
}

/* ── お支払いへ ── */
async function xcSubmit() {
  const btn = document.getElementById('xc-submit');
  const contact = xcReadContact();
  if (!contact) return;
  if (!xcSel.cake || !xcSel.date || !xcSel.time) {
    alert('ケーキとお受け取り日時をお選びください。');
    return;
  }

  btn.disabled = true;
  btn.textContent = 'お支払いへ進んでいます…';

  if (!Object.keys(xcVariantMap).length) await xcFetchVariants();
  const variantId = xcVariantMap[xcVariantKey(xcSel.cake.name, xcSel.size)];
  if (!variantId) {
    alert('申し訳ございません。ただいまこの組み合わせを承れません。お手数ですがお電話にてご連絡ください。');
    btn.disabled = false;
    btn.textContent = 'お支払いへ進む';
    return;
  }

  const properties = {
    'お受け取り日': xcLongDate(xcSel.date),
    'お受け取り時間': xcSel.time,
    'ケーキ': xcSel.cake.name,
    'サイズ': xcSel.size,
    'お名前': contact.name,
    'お電話番号': contact.phone,
    'メール': contact.email,
    'お支払い方法': 'オンライン決済',
  };
  const remarks = document.getElementById('xc-remarks').value.trim();
  if (remarks) properties['その他ご要望'] = remarks;

  try {
    /* ひとつのご予約にひとつのお会計。前に入れたままのものがあれば流します。 */
    await fetch('/cart/clear.js', { method: 'POST' });
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: properties }] }),
    });
    if (!r.ok) {
      /* カートの不具合は JSON で返りますが、パスワードの画面やボット確認は
         HTML で返ります。そのまま JSON として読むと、本当の原因が
         「通信エラー」の一言に隠れてしまいます。 */
      let msg = 'HTTP ' + r.status;
      try {
        const e = await r.json();
        msg = e.description || e.message || msg;
      } catch (_) { /* JSON でなければ、状態コードのまま */ }
      alert('エラー: ' + msg);
      btn.disabled = false;
      btn.textContent = 'お支払いへ進む';
      return;
    }
    window.location.href = '/checkout';
  } catch (e) {
    console.error(e);
    alert('通信に失敗しました。電波の良いところで、もう一度お試しください。');
    btn.disabled = false;
    btn.textContent = 'お支払いへ進む';
  }
}

/* ── 立ち上げ ──
 *
 * 一度だけ。読み込みの進み具合によって DOMContentLoaded を待つ場合と
 * すぐ動く場合があり、どちらも通るように書いてあるので、二度目は何もしません
 * （聞き耳が二重について、押すたびに二回進むのを防ぐため）。 */
let xcStarted = false;

function xcInit() {
  if (xcStarted) return;
  if (!document.getElementById('xc-form')) return;
  xcStarted = true;
  xcRenderCakes();
  xcRenderDates();
  xcRenderTimes();
  xcUpdateBar();

  Array.prototype.forEach.call(document.querySelectorAll('[data-xc-pick]'), function (row) {
    const parts = String(row.dataset.xcPick).split('|');
    row.addEventListener('click', function () { xcPickFromLineup(parts[0], parts[1]); });
  });

  document.getElementById('xc-next1').addEventListener('click', function () { xcGoTo(2); });
  document.getElementById('xc-next2').addEventListener('click', function () { xcGoTo(3); });
  document.getElementById('xc-next3').addEventListener('click', function () {
    if (xcReadContact()) xcGoTo(4);
  });
  document.getElementById('xc-submit').addEventListener('click', xcSubmit);

  Array.prototype.forEach.call(document.querySelectorAll('[data-xc-back]'), function (b) {
    b.addEventListener('click', function () { xcGoTo(Number(b.dataset.xcBack)); });
  });
  ['xc-family', 'xc-given', 'xc-phone', 'xc-email'].forEach(function (id) {
    const el = document.getElementById(id);
    if (el) el.addEventListener('input', xcCheckStep3);
  });
  Array.prototype.forEach.call(document.querySelectorAll('[data-xc-agree]'), function (b) {
    b.addEventListener('change', xcCheckStep3);
  });

  xcCheckStep2();
  xcCheckStep3();
  xcFetchVariants();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', xcInit);
} else {
  xcInit();
}
